export const constants = {
    LANG_FR: 'fr',
    LANG_EN: 'en',
    LANG_DE: 'de',
}